export default [
    {
        section: 'Product',
        types: ['general'],
        question: 'What is Coral?',
        answer: `             <p>
                            An innovative new app that shows you how to have your best sex life through personalized lessons, guided exercises, real stories and more.
                        </p>`
    },
    {
        section: 'Product',
        types: ['general'],
        question: 'Who is Coral for?',
        answer: ` <p>
                            Anyone interested in better sex. At Coral all people are valued, regardless of sexual orientation, gender identity, race or nationality.
                        </p>`
    },
    {
        section: 'Product',
        types: ['general'],
        question: 'What do the icons mean?',
        answer: `     <p>
                            <i class="ion-headphone" /> - Unit has audio<br>
                            <i class="ion-android-funnel" /> - Unit has versions, we will select the appropriate version for you depending on your traits.<br>
                            <i class="ion-person-stalker" /> - Unit requires a partner to complete.<br>
                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['general'],
        question: 'Can I use Coral for free?',
        answer: `<p>
                            Absolutely! In addition to The Pulse (your weekly sex tracker) and daily Coral we’ve made a number of lessons, exercises, stories and quizzes available to non-subscribers in the app and will be adding more periodically. You can see some community conversations, but you can’t participate. In order to take advantage of the full range of our content (including new units added weekly) and access your personalized journey we’d recommend a subscription.
                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['general'],
        question: 'What do I get if I subscribe?',
        answer: ` <p>
                            The full Coral experience! This includes unrestricted access to your personalized journey, The Pulse (your weekly sex tracker) and our community. We also give you complete access to our new lessons, exercises, stories and quizzes that are added weekly!
                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['billing', 'default'],
        question: 'How do I cancel my subscription?',
        answer: `  <p>
                            From the <f7-link href="/subscription">subscription</f7-link> page, you have several options depending on how you purchased your subscription.
                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['general'],
        question: 'Can I gift Coral?',
        answer: `  <p>
                            Yes! You can give the gift of horizontal happiness and show someone how much they mean to you with 12 months of Coral for $59.99.
                            <br><br>
                            (Gift codes are valid for six months after date of purchase)
                            <br><br>
                            <f7-link
                                href="https://getcoral.app/gift"
                                external
                                target="_system"
                            >https://getcoral.app/gift</f7-link>

                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['billing', 'default'],
        question: 'How do I get a refund?',
        answer: `   <p>
                            If you’d like a refund for any reason you’ll have to request one through Apple or Google Play depending on which store is managing your subscription.
                            <br><br>
                            If you’re on an Apple device:
                            <br><br>
                            The best way to request a refund is through Apple’s customer support. Read about Apple’s refund policy and how to request a refund <f7-link
                                href="https://support.apple.com/en-us/HT204084"
                                external
                                target="_system"
                            >here</f7-link>.
                            <br><br>

                            If you’re on an Android device:
                            <br><br>
                            Read about Google’s refund policy and how to request a refund from the Google play store <f7-link
                                href="https://support.google.com/googleplay/answer/2479637#apps"
                                external
                                target="_system"
                            >here</f7-link>.
                        </p>`
    },
    {
        section: 'Billing / Subscription',
        types: ['billing'],
        question: 'Can I subscribe on a monthly basis?',
        answer: ` <p>
                            Subscriptions are charged as a one-time fee for 12 months of access which breaks down to $5 a month, which means better sex, more mindfulness and skills that are beneficial both in and out of the bedroom for less than a Starbucks Grande!
                        </p>`
    },
    {
        section: 'Partners',
        types: ['partner'],
        question: 'How do I link our accounts?',
        answer: `<ol>
                            <li>In the app, go to the "Me" tab on the bottom right hand corner of your screen.</li>
                            <li>In the upper right hand corner, click on the gear to open Settings.</li>
                            <li>Scroll down to where you see "Partner." </li>
                            <li>Select the "Invite your partner" button.</li>
                            <li>If they already have an account please use the email or phone number they used to sign up. If they have not signed up yet, enter the email or phone number they will use to sign up.</li>
                            <li>Write them a message and click "Send."</li>
                        </ol>
                        <p>Your partner will receive an email or SMS with your invitation.

                        </p>`
    },
    {
        section: 'Partners',
        types: ['partner'],
        question: "I haven't paid, can I still link my partner? ",
        answer: ` <p>
                            You can absolutely link your accounts, however, you won’t get the full benefits of partner mode (read: buy one subscription, get one free) unless one of you has subscribed.
                        </p>`
    },
    {
        section: 'Partners',
        types: ['partner'],
        question: 'I sent the link to the wrong address...',
        answer: ` <p>
                            You can unlink a pending invitation and resend the invite.
                            <br><br>
                            Double check the linked accounts by going back to Me > Settings and selecting "Partner." Select the email or phone number to unlink the invitation and then follow the steps to set your partner up again.

                        </p>`
    },
    {
        section: 'Privacy and data',
        types: ['data', 'default'],
        question: 'How do you keep my data safe?',
        answer: `  <p>
                            Exploiting your data isn’t our business. We are committed to creating the safest, most trustworthy environment for our users to develop and grow. We’re conscious of the sensitive information we are collecting and we take your privacy very seriously, which is why we follow GDPR privacy guidelines (the world's strongest data protection rules).
                            <br><br>
                            For more detailed information, including our complete privacy policy, visit “Privacy” under Settings in the app or read our privacy policies <f7-link href="/privacy">here</f7-link>.<br><br>
                            Please reach out to support@getcoral.app if you would like any further info.

                        </p>`
    },
    {
        section: 'Privacy and data',
        types: ['data', 'communication'],
        question: 'How do I delete my data?',
        answer: ` <p>
                            Under GDPR regulations you have the “right to be forgotten” which includes the ability to view, download or delete your data at any time.
                            <br><br>
                            Data will be deleted from our servers instantly after a deletion request has gone through to all our analytics and other data providers. Keep in mind: some data may remain in our automated backups for up to 21 days after which it will be completely erased.
                            <br><br>
                            If you would like to request or delete your data, we have a simple button for this <f7-link href="/data">here</f7-link>.
                        </p>`
    },
    {
        section: 'Privacy and data',
        types: ['data', 'communication'],
        question: 'How do I unsubscribe from email/text',
        answer: `<p>
                            To unsubscribe from all Coral text messages:<br>
                            You can reply "STOP" to the last text received to end all text messages.
                            <br><br>
                            To unsubscribe from all Coral emails:<br>
                            Edit your email settings under the “Communications” section in Settings or click on the “Unsubscribe” option at the bottom of any Coral email.
                        </p>`
    }
];
